export default __webpack_public_path__ + "static/media/KIDS.ba1ac133.png";